import React from "react";
import style from "./Views.module.css";

export default function Oro() {
  return (
    <div className={style.container}>
      <div className={style.oroGalley}>Oro Gallery</div>
    </div>
  );
}
